
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.674 37.013h-13.34A3.334 3.334 0 017 33.678V10.335A3.334 3.334 0 0110.335 7H32.01a3.334 3.334 0 013.335 3.335v8.163M14 20.4h5M22 20.4h6M14 14h7M28 14h-4","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.134 27c-.888 1.177-1.75 2.48-2.08 3.94-.155.681-.02 1.864 1 1.445.307-.127 1.814-1.744 1.954-1.605.238.238.106.58.611.469.475-.105.867-.491 1.215-.802.434-.387.957-.099 1.525-.048 1.002.09 2.078.712 3.05.429","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.664 26.723c3.827 0 7.08-1.968 8.33-4.724v.84c0 5.01-3.683 9.098-8.33 9.404v3.917L26 29.496l6.664-6.664v3.888","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M32.664 26.723c3.827 0 7.08-1.968 8.33-4.724v.84c0 5.01-3.683 9.098-8.33 9.404v3.917L26 29.496l6.664-6.664v3.888","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    